export enum enumCustomEventLogState {
  SUCCESS = 'success',
  FAILED = 'failed',
}
